import containerFuild from '../html-snippets/container-fuild';
import buttonPrimary from '../../ui-modules/button-primary/raw-html';
import css from '../tpl-css/style-section-calyrafit-collections';

const btnPrimary = buttonPrimary({
  radius: 100,
  backgroundColor: '#AD4870',
  text: 'Try tt today, risk-free !',
  link: '#',
  iconSuffix: {
    show: true,
    src: 'https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1f8d129be3c6ed1534bd6.png',
  },
  policy: {
    show: true,
    colPerView: 2,
    alignContent: 'center',
    items: [
      {
        icon: 'https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1fa18f00e27b64639403f.png',
        text: '30-DAY MONEY-BACK GUARANTEE',
      },
      {
        icon: 'https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1fa1cc31ce502e333c990.png',
        text: 'FREE RETURNS, NO QUESTIONS ASKED',
      },
    ],
  },
});

const items = [
  {
    link: '#',
    image: 'https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1f9ae3006df8769e90141.png',
    content: '<p>30% Push-Up Effect</p>',
  },
  {
    link: '#',
    image: 'https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1f9b1fc0fa1ea7f6dfb19.png',
    content: '<p>Shapes Your Waist</p>',
  },
  {
    link: '#',
    image: 'https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1f9b541a23fc897a28f6c.png',
    content: '<p>Promotes Blood Circulation</p>',
  },
  {
    link: '#',
    image: 'https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1f9b9aef0cd65d9e66191.png',
    content: '<p>Wireless Front-Closure Lift</p>',
  },
];

const renderItem = item => `
  <div class="swiper-slide">
    <a href="${item.link || '#'}" data-attribute="item" class="item-collections">
      <div class="wrap-iamge">
        <img data-attribute="image-item" src="${item.image || ''}" alt="" />
      </div>
      <div data-attribute="title" class="title-collections">${item.content || ''}</div>
    </a>
  </div>
`;

const html = `
<div
  data-use-custom-width="false"
  data-custom-width="1204"
  class="container marquee-group"
  data-attribute="container-content"
  style="--custom-width: 1204px;"
>
  <div data-show="true" data-attribute="card-title" class="card-title">
    <h2 style="text-align:center;">
      Why Women Choose <span style="color:#ad4870;"><i>CalyraFit™</i></span>
    </h2>
    <p style="text-align: center;">
      Designed to smooth, sculpt, and support your body with every move, so you can feel more confident from the moment
      you put them on.
    </p>
  </div>
  <div class="block-slider swiper">
    <div data-attribute="list-item" class="swiper-wrapper">
      ${items.map(renderItem).join('')}
    </div>
  </div>

  <div data-attribute="wrap-btn-dynamic-primary" class="wrap-btn-dynamic-primary">
    ${btnPrimary}
  </div>
</div>
`;

export default containerFuild(html, css, {
  backgroundColor: '#FCF8F9',
});
